export const Group = {
  Interns: "interns",
  Employees: "employees",
  Volunteers: "volunteers",
};

export const ChatProvider = {
  Microsoft: "Microsoft",
  Google: "Google",
};

export const DataSourceNames = {
  CHAT: "Chat",
  JIRA: "Jira",
  GERRIT: "Gerrit",
  CALENDAR: "Calendar",
};

export const JiraIssueStatus = {
  TODO: "todo",
  IN_PROGRESS: "in_progress",
  DONE: "done",
};
